import React from 'react';
import { Redirect, Route } from 'react-router';
import { AppState } from '..';
import { connect } from 'react-redux';
import { IAuthReducerState } from '../reducers/authReducer';

interface IPrivateRoute {
  authReducer: IAuthReducerState,
  [key: string]: any
}
/**
 * wrapper around Route to create a private (logged) route
 * @param props
 */
const _PrivateRoute: React.FC<IPrivateRoute> = ({ authReducer, ...props }) => {
  const { parsedToken } = authReducer;
  if (!parsedToken) {
    return <Redirect to="/login" />
  }

  return <Route {...props} />
}
export const PrivateRoute = connect((state: AppState) => ({ authReducer: state.auth }), null, null, { pure: false })(_PrivateRoute)

interface IPublicRoute {
  authReducer: IAuthReducerState,
  [key: string]: any
}

const _PublicRoute: React.FC<IPublicRoute> = ({ authReducer, ...props }) => {
  const { parsedToken } = authReducer;

  if (parsedToken) {
    return <Redirect to="/" />
  }

  return <Route {...props} />
}
// HOC connect implements the shouldComponentUpdate hook that does a shallow comparison of the props to avoid a rerendering if unnecessary
// 'pure: false' will simply disable this check to allow always a rerendering (even if the url changes -> history object)
export const PublicRoute = connect((state: AppState) => ({ authReducer: state.auth }), null, null, { pure: false })(_PublicRoute);